import { withBooleanFeatureFlag, Property } from '@greystar/lib';
import {
  GetStaticComponentProps,
  withDatasourceCheck,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { PropertyDetailsAmenitiesProps, PropertyAmenities } from '@greystar/ui';
import React, { JSX } from 'react';
import { PageSection, PageSectionContent } from '@greystar/designsystem';

const PropertyDetailsAmenities = (props: PropertyDetailsAmenitiesProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();

  if (props.data.notFound) {
    return <></>;
  }

  return (
    <PageSection isTopFlushed>
      <PageSectionContent hasMaxWidth>
        <PropertyAmenities
          title={props.fields?.title?.value ?? ''}
          highlightsTitle={props.fields?.highlightsTitle?.value ?? ''}
          featuresTitle={props.fields?.featuresTitle?.value ?? ''}
          amenitiesTitle={props.fields?.amenitiesTitle?.value ?? ''}
          highlights={props.data.highlights}
          features={props.data.features}
          amenities={props.data.amenities}
          isPageEditing={sitecoreContext.pageEditing}
        />
      </PageSectionContent>
    </PageSection>
  );
};

export const getStaticProps: GetStaticComponentProps = async (
  rendering,
  layoutData
): Promise<PropertyDetailsAmenitiesProps> => {
  const props = rendering as unknown as PropertyDetailsAmenitiesProps;
  const property = layoutData.sitecore.context.property as Property;

  if (!property) {
    return {
      ...props,
      data: {
        highlights: null,
        features: null,
        amenities: null,
        notFound: true,
      },
      flagKey: rendering.componentName,
      isPageEditing: layoutData.sitecore.context.pageEditing,
    };
  }

  return {
    ...props,
    data: {
      highlights: property.highlights ?? null,
      features: property.features ?? null,
      amenities: property.amenities ?? null,
      notFound: false,
    },
    flagKey: rendering.componentName,
    isPageEditing: layoutData.sitecore.context.pageEditing,
  };
};

export default withDatasourceCheck()<PropertyDetailsAmenitiesProps>(
  withBooleanFeatureFlag(PropertyDetailsAmenities)
);
